'use client';

import { SectionContent } from "@/types/sections.model";
import { Box, Stack, Typography, Button, Container } from "@mui/material";
import FadeIn from "../ui/FadeIn";

const Anchor: React.FC<{ section: SectionContent<'anchor'> }> = ({ section }) => {
  const { id, items } = section;

  const handleClick = (link: string) => {
    if (link.startsWith('#')) {
      const element = document.getElementById(link.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <Box id={id} py={{xs: 12, lg: 17}}>
      <FadeIn>
        <Container
          sx={{
            overflowX: { xs: "auto", md: "visible" },
            overflowY: "hidden",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              display: "none"
            },
            WebkitOverflowScrolling: "touch",
          }}
        >
            <Stack 
              direction="row" 
              spacing={20} 
              justifyContent={{ xs: "flex-start", md: "center" }}
              alignItems="center" 
              flexWrap={{ xs: "nowrap", md: "wrap" }}
              role="navigation"
              aria-label="Navigazione sezioni pagina"
              sx={{
                minWidth: { xs: "max-content", md: "auto" }
              }}
            >
              {items.map((item, index) => (
                <Button
                  key={`button-${index}-${item.label}`}
                  onClick={() => handleClick(item.link)}
                  sx={{ 
                    textDecoration: 'none',
                    minWidth: 'auto',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                  }}
                  aria-label={`Vai alla sezione ${item.label}`}
                >
                  <Typography variant="subtitleLG" component="span" color="primary">
                    {item.label}
                  </Typography>
                </Button>
              ))}
            </Stack>

        </Container>
      </FadeIn>
    </Box>
  )
}

export default Anchor;